import { CTA_GRADIENT } from '@/features/billboards/constants/detailTheme';
import { resolveCampaignCtaLabel } from '@/features/billboards/utils/billboardDetailUtils';

type MobileCampaignBarProps = {
  basePrice?: number;
  currency: string;
  hasToken: boolean;
  canCreate: boolean;
  isClient?: boolean;
  onCreate: () => void;
};

export function MobileCampaignBar({
  basePrice,
  currency,
  hasToken,
  canCreate,
  isClient = false,
  onCreate,
}: MobileCampaignBarProps) {
  const disabled = hasToken && !canCreate && !isClient;

  /* Modified by: Ishan | Soft-contrast mobile floating campaign bar */
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[#EEEBF8] bg-white/95 p-3 backdrop-blur-md shadow-[0_-4px_20px_rgba(60,40,120,0.08)] lg:hidden">
      <div className="mx-auto flex max-w-[1120px] items-center gap-3">
        <div className="min-w-0 flex-1 text-left">
          <p className="truncate text-xs font-medium text-[#6A6688]">From</p>
          <p className="truncate text-sm font-bold text-[#3A3660]">
            {basePrice ?? 0} {currency}
            <span className="font-normal text-[#6A6688]"> /sec</span>
          </p>
        </div>
        <button
          type="button"
          disabled={disabled}
          onClick={onCreate}
          className="shrink-0 cursor-pointer rounded-full px-5 py-2.5 text-sm font-bold text-white transition hover:opacity-95 shadow-sm disabled:cursor-not-allowed disabled:bg-[#EAE8F5] disabled:text-[#8E8AA8]"
          style={disabled ? undefined : { background: CTA_GRADIENT }}
        >
          {resolveCampaignCtaLabel(hasToken, canCreate, true, isClient)}
        </button>
      </div>
    </div>
  );
}
